interface SelectionGuideProps {
  onOpenDrawer?: (source?: string, needTax?: boolean) => void;
}

export default function SelectionGuide({ onOpenDrawer }: SelectionGuideProps) {
  return (
    <section className="bg-gradient-to-br from-gray-50 to-white py-16">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-lg p-10">
          <div className="flex items-start gap-6">
            {/* 左侧图标 */}
            <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-[#14B8A6]/10 flex-shrink-0">
              <i className="ri-guide-line text-[#14B8A6] text-3xl"></i>
            </div>

            {/* 右侧内容 */}
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">怎么选更合适？</h3>

              <div className="grid grid-cols-3 gap-6 mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-arrow-right-circle-fill text-[#14B8A6] text-xl mt-1 flex-shrink-0"></i>
                  <div>
                    <div className="font-medium text-gray-900 mb-1">只想先验证闭环</div>
                    <div className="text-sm text-gray-600">选 A类工具</div>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-arrow-right-circle-fill text-[#14B8A6] text-xl mt-1 flex-shrink-0"></i>
                  <div>
                    <div className="font-medium text-gray-900 mb-1">需要长期合规治理</div>
                    <div className="text-sm text-gray-600">选 订阅版</div>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-arrow-right-circle-fill text-[#14B8A6] text-xl mt-1 flex-shrink-0"></i>
                  <div>
                    <div className="font-medium text-gray-900 mb-1">有退税/核算/值守需求</div>
                    <div className="text-sm text-gray-600">在订阅版基础上加购服务包</div>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <button
                  onClick={() => {
                    const element = document.getElementById('version-recommender');
                    element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }}
                  className="bg-[#14B8A6] text-white px-8 py-3 rounded-lg font-medium hover:bg-[#12a594] transition-colors whitespace-nowrap cursor-pointer"
                >
                  去选订阅版本
                </button>
                <button
                  onClick={() => onOpenDrawer?.('A类工具', false)}
                  className="bg-white text-gray-700 px-8 py-3 rounded-lg font-medium border border-gray-300 hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  先跑通一票
                </button>
                <button
                  onClick={() => onOpenDrawer?.('咨询方案', false)}
                  className="bg-white text-gray-700 px-8 py-3 rounded-lg font-medium border border-gray-300 hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  咨询方案
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}